/*
 * Created by jmeo at 2021-06-02
 * FileName: Entrust.tsx
 * 个人征信授权书
 */

import {setTitle} from "@src/util";
import CustomScroll from '@src/component/customScroll'
export default function () {
    setTitle('个人征信信息授权书')
    return <div className="page bottomFit"><CustomScroll><div className="agreement">
        <h2>个人征信信息授权书</h2>
        <p><strong>重要提示：</strong></p>
        <p>为了保障您的合法权益，您应当阅读并遵守本授权书。请您务必审慎阅读、充分理解本授权书条款内容，特别是免除或者减轻被授权人责任，或限制您权利的条款，相关条款将以加粗形式提示您充分注意。</p>
        <p>百行征信有限公司（以下统称“百行征信”）是依据《征信业管理条例》成立和运营的持牌个人征信机构，本授权书依据《征信业管理条例》等法律法规的相关规定拟定。</p>
        <p>本人向润雨同舟 (深圳) 融资租赁有限公司公司、百行征信作以下授权：</p>
        <p>一、本人同意（本文简称“被授权人”）在办理以下涉及到本人或与本人有关的业务时，可按照法律法规的规定通过百行征信查询、使用本人的信用评价类信息：</p>
        <p>☐审核本人授信及贷款申请的；</p>
        <p>☐审核本人作为被担保人或共同还款人、借款人的；</p>
        <p>☐受理法人、其他组织或自然人的授信、贷款申请及贷后风险管理时，需要查询本人作为法人、其他组织或自然人的法定代表人、出资人或关联方的信用状况的；</p>
        <p>☐受理本人担任法定代表人、负责人或出资人的法人、商户或其他组织的特约商户开户申请，需要查询本人信用状况的；</p>
        <p>☐处理贷后管理事务（包括贷款额度授予后对额度的管理），进行贷后风险管理；</p>
        <p>☐处理本人征信异议的。</p>
        <p><strong>二、本人同意百行征信基于开展征信业务目的，有权向被授权人和合法留存本人信息的机构（包括但不限于公安、司法、教育、全国公民身份证号码查询服务中心、通信运营商、银联、社保、公积金、税务、民政、物流、电子商务平台、互联网平台、行业协会等合法留存本人信息的第三方机构等）查询、核实、收集如下信息：本人的基本信息、借贷信息、其他相关信息，</strong>包括但不限于本人的身份、地址、交通、通信、债务、财产、支付、消费、生产经营、履行法定义务等信息，以及基于前述信息对个人信用状况形成的分析、评价类信息、可能对本人产生负面影响的不良信息。本人同意<strong>百行征信采集本条约定的前述信息之前，本人已经理解并知悉提供该等信息可能会对本人产生的影响。</strong></p>
        <p><strong>三、本人同意百行征信有权对从合法留存本人信息的机构采集的本人信息进行存储、整理、保存、加工，并将采集的信息或信息处理结果提供给经本人授权的第三方使用。</strong></p>
        <p>四、信息查询、保存期限</p>
        <p>1、信息查询期限：本授权书项下被授权人查询本人信息的期限自本人确认本授权承诺之日起至本人在被授权人处所有相关业务终结之日止。</p>
        <p>如下情形视为本人与被授权人的业务未终结：本人在被授权人处有信贷余额或有授信额度、本人提供担保的授信业务有信贷余额或有授信额度、本人尚有未结清款项。</p>
        <p>2、信息保存期限：<strong>个人不良信息的保存期限，自不良行为或者事件终止之日起5年。</strong></p>
        <p>五、授权人声明</p>
        <p><strong>本人已知悉并理解本授权书所有内容（特别是加粗字体内容）以及由此产生的法律效力，自愿作出上述授权。</strong></p>
        <br/>
    </div></CustomScroll></div>
}